export const SIDEBAR_WIDTH = 270;
export const HIDDEN_SIDEBAR_WIDTH = 20;
export const HEADER_HEIGHT = 78;
